import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

const TaskDetailsCompletedLabel = ({ isCompleted }) => {
  const [show, setShow] = useState(isCompleted);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (isCompleted) {
      setShow(true);
      const t = setTimeout(() => setAnimate(true), 10);
      return () => clearTimeout(t);
    } else {
      setAnimate(false);
      const t = setTimeout(() => setShow(false), 200);
      return () => clearTimeout(t);
    }
  }, [isCompleted]);

  if (!show) return null;

  return (
    <div
      className="flex items-center justify-center gap-2 py-2 sticky top-0 z-[10]"
      style={{
        background: '#ecfdf5',
        borderBottom: '1px solid rgba(16,185,129,0.22)',
        transform: animate ? 'translateY(0)' : 'translateY(-100%)',
        opacity: animate ? 1 : 0,
        transition: 'transform 0.25s cubic-bezier(0.34,1.56,0.64,1), opacity 0.2s ease',
      }}
    >
      <svg width="14" height="14" viewBox="0 0 16 16" fill="#059669">
        <path d="m2.457 8.516.969-.99 2.516 2.481 5.324-5.304.985.989-6.309 6.284z" />
      </svg>
      <span className="text-[12.5px] font-semibold" style={{ color: '#059669' }}>
        Task Completed
      </span>
    </div>
  );
};

const mapStateToProps = (state) => {
  const taskId = state?.generalReducer?.openedTaskId;
  const task = state?.tasks?.entities?.[taskId];
  return {
    isCompleted: task?.isCompleted ?? false,
  };
};

export default connect(mapStateToProps)(TaskDetailsCompletedLabel);
